const lesewebId = 'iskm34glix46h3tmb7by'
export const lesewebApi = `https://speech.leseweb.dk/script/${lesewebId}.js`



// WEBPACK FOOTER //
// ./src/config/leseweb.js